import React, { forwardRef } from 'react';
import { Check } from 'lucide-react';
import { classNames } from '../../utils/classNames';
import { useI18n } from '../../hooks/useI18n';

export const MessageSuggestions = forwardRef(function MessageSuggestions(
  { suggestions = [], selected = [], onToggle, disabled = false },
  ref
) {
  const { t } = useI18n();

  if (!suggestions.length) {
    return null;
  }

  return (
    <div ref={ref} className="mt-3 flex w-full flex-col gap-1.5">
      <p className="px-0.5 text-xs font-medium text-neutral-400">{t('nextStep')}</p>
      <div role="list" aria-label={t('aiSuggestions')} className="flex w-full flex-col gap-1.5">
        {suggestions.map((label, index) => {
          const isSelected = selected.includes(label);

          return (
            <button
              key={`${label}-${index}`}
              type="button"
              role="listitem"
              aria-pressed={isSelected}
              disabled={disabled}
              onClick={() => onToggle?.(label)}
              className={classNames(
                'flex w-full items-start gap-2.5 rounded-2xl border px-3 py-2.5 text-start text-sm leading-snug transition disabled:opacity-50',
                isSelected
                  ? 'border-neutral-900 bg-neutral-900 text-white dark:border-white dark:bg-white dark:text-neutral-950'
                  : 'border-neutral-200 bg-white text-neutral-700 hover:border-neutral-300 hover:bg-neutral-50 dark:border-border dark:bg-panel dark:text-text dark:hover:border-accent/30 dark:hover:bg-accent-soft'
              )}
            >
              <span
                className={classNames(
                  'mt-0.5 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full border',
                  isSelected
                    ? 'border-white bg-white text-neutral-950 dark:border-neutral-950 dark:bg-neutral-950 dark:text-white'
                    : 'border-neutral-300 dark:border-neutral-600'
                )}
              >
                {isSelected ? <Check size={11} strokeWidth={3} /> : null}
              </span>
              <span className="min-w-0 whitespace-normal break-words">{label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
});
